goog.provide('el8.uiwidget.MinLengthPasswordFields');

goog.require('el8.model.base');
goog.require('el8.uiwidget.NewPasswordFields');


/**
 * This is a subclass of the NewPasswordFields widget, which relaxes
 * the password requirement to just a minimum length requirement. The
 * default min length is 8 characters.
 */
el8.uiwidget.MinLengthPasswordFields = function(spec) {
    spec = spec || {};
    this._minLength = spec.minLength || 8;

    el8.uiwidget.NewPasswordFields.apply(this, arguments);
};
el8.uiwidget.MinLengthPasswordFields.inheritsFrom(el8.uiwidget.NewPasswordFields);


el8.uiwidget.MinLengthPasswordFields.prototype.validateField1 = function(delayError) {

    if (this._timeoutId1) { clearTimeout(this._timeoutId1); }

    var that = this;
    var val = that._field1.val();
    if (val.length > 0) {
        if (val.length < this._minLength) {
            var tooShortFn = function() {
                that._getInfoDiv1().text(
                    'Password too short. Must be at least ' + that._minLength + ' characters.'
                );
                if (that._errorClass) { that._getInfoDiv1().addClass(that._errorClass); }
            };
            // Only delay error if user didn't previously see an alert msg
            if (delayError && !that._getInfoDiv1().text()) {
                this._timeoutId1 = setTimeout(function() { tooShortFn(); }, this._DELAY);
            } else {
                tooShortFn();
            }
        } else {
            that._getInfoDiv1().empty();
            if (that._errorClass) { that._getInfoDiv1().removeClass(that._errorClass); }
        }
    } else {
        that._getInfoDiv1().empty();
        if (that._errorClass) { that._getInfoDiv1().removeClass(that._errorClass); }
    }
};

el8.uiwidget.MinLengthPasswordFields.prototype.showError1 = function() {
    this._getInfoDiv1().text(
        'Password too short. Must be at least ' + this._minLength + ' characters.'
    );
    if (this._errorClass) { this._getInfoDiv1().addClass(this._errorClass); }
};

// field2 can continue to work exactly the same way, so it's just inherited from NewPasswordFields